import { render, staticRenderFns } from "./EditPaper.vue?vue&type=template&id=f274706c&"
import script from "./EditPaper.vue?vue&type=script&lang=js&"
export * from "./EditPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports